import acceptLanguageParser from "accept-language-parser";

export const getLocaleFromAcceptLanguage = (acceptLanguage: string): string => {
  const parsed = acceptLanguageParser.parse(acceptLanguage);
  const first = parsed[0];

  if (!first) {
    return "en-US";
  }

  let lang = first.code;

  if (first.code === "*") {
    return "en-US";
  }

  if (first.region) {
    lang = `${lang}-${first.region}`;
  }

  return lang;
};

export const getCurrencyFormatter = (locale: string, currency: string) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  });
};
